module.exports = __webpack_public_path__ + "media/customizations/svlaliving/back-909d9f8dd7b5505b533d12bb9e266dbd.jpg";